import type { StudySummaryDto } from "@/entities/study/models/dtos";

export class StudyBehavior {
    private aggregateProperty = (
        studySummaryDto: StudySummaryDto,
        propertyName: string,
    ): number => {
        let total = 0;
        const studyItems = studySummaryDto.studyItems;

        studyItems.forEach((studyItem) => {
            // Process solvingStatuses
            if ("solvingStatuses" in studyItem && studyItem.solvingStatuses) {
                studyItem.solvingStatuses.forEach((solvingStatus) => {
                    if (propertyName in solvingStatus) {
                        total += solvingStatus[
                            propertyName as keyof typeof solvingStatus
                        ] as number;
                    }
                });
            }

            // Process studyReviewSummary.problemSolvingStatuses
            if ("studyReviewSummary" in studyItem && studyItem.studyReviewSummary) {
                const problemSolvingStatuses = studyItem.studyReviewSummary.problemSolvingStatuses;
                problemSolvingStatuses.forEach((problemSolvingStatus) => {
                    if (propertyName in problemSolvingStatus) {
                        total += problemSolvingStatus[
                            propertyName as keyof typeof problemSolvingStatus
                        ] as number;
                    }
                });
            }
        });

        return total;
    };

    public getCorrectCount = (studySummaryDto: StudySummaryDto): number => {
        return this.aggregateProperty(studySummaryDto, "correctProblemCount");
    };

    public getSubmittedCount = (studySummaryDto: StudySummaryDto): number => {
        return this.aggregateProperty(studySummaryDto, "submittedProblemCount");
    };

    public getElapsedTime = (studySummaryDto: StudySummaryDto): number => {
        return this.aggregateProperty(studySummaryDto, "totalProblemElapsedTime");
    };

    public getCorrectedAfterWrongCount = (studySummaryDto: StudySummaryDto): number => {
        return this.aggregateProperty(studySummaryDto, "correctedAfterWrongProblemCount");
    };

    public getWrongInRepeatedCount = (studySummaryDto: StudySummaryDto): number => {
        return this.aggregateProperty(studySummaryDto, "wrongInRepeatedProblemCount");
    };

    public getSelfEvaluatedAsWorseCount = (studySummaryDto: StudySummaryDto): number => {
        return this.aggregateProperty(studySummaryDto, "selfEvaluatedAsWorseAnswerCount");
    };
}
